import React from 'react';
import c from 'classnames';
import { Menu, CoreLink } from '@uncinc/react-drupal-core';

import { CONTACT_BLOCK_TITLE_IDENTIFIER } from '../../../config/constants';
import useCurrentPage from '../../../helpers/useCurrentPage';

import './style.scss';

const MenuMain = ({ setOverlayMenuVisible, id = 'main' }) => {
  const [isCurrentPage] = useCurrentPage();

  return (
    <Menu className="menu-main" id={id}>
      {(items) => items.map((item) => {
        if (item) {
          const title = item.getIn(['link', 'title'], 'Untitled');
          const url = item.getIn(['link', 'url'], '');

          const MainMenuItemClassnames = c('MainMenu__item', {
            'MainMenu__item--active': isCurrentPage(url),
          });

          if (title === CONTACT_BLOCK_TITLE_IDENTIFIER) {
            return;
          }

          return (
            <div
              key={title}
              className={MainMenuItemClassnames}
            >
              <CoreLink
                className="MainMenu__item__link"
                onClick={() => setOverlayMenuVisible(false)}
                href={url}
              >
                <span className="MainMenu__item__title">{title}</span>
              </CoreLink>
            </div>
          );
        }
      })}
    </Menu>
  );
};

export default MenuMain;
